import { FEDERAL_TAX_BRACKETS, STANDARD_DEDUCTION } from '../constants/taxConstants';

// Federal tax on pay after the standard deduction, and the rate on its last dollar.
export function payTax(income, filingStatus) {
  const brackets = FEDERAL_TAX_BRACKETS[filingStatus] || FEDERAL_TAX_BRACKETS.single;
  const dedEntry = STANDARD_DEDUCTION[filingStatus] || STANDARD_DEDUCTION.single;
  const deduction = typeof dedEntry === 'object' ? (dedEntry.amount || 0) : (dedEntry || 0);
  const taxable = Math.max(0, income - deduction);
  let tax = 0;
  let rate = brackets[0].rate;
  for (const bracket of brackets) {
    if (taxable <= bracket.min) break;
    tax += (Math.min(taxable, bracket.max) - bracket.min) * bracket.rate;
    rate = bracket.rate;
  }
  return { tax, rate };
}

/**
 * Tax deferred by putting `amount` of pay into a pre-tax account when
 * `already` has gone in before it: the difference between the two tax bills,
 * so a contribution that crosses into a lower bracket is not all counted at
 * the higher rate.
 */
export const taxDeferred = (income, filingStatus, already, amount) => (
  payTax(income - already, filingStatus).tax - payTax(income - already - amount, filingStatus).tax);
